import type {AstView, EnrichedAstNode} from '../../types';
import {setupAbsolutePositionParent, absolutePositionSingleChildren} from '../CssAdjustments';

export const adjustForEditorDefinedLayout = (view: AstView, node: EnrichedAstNode) => {
    node.children.forEach((child) => {
        if (child.meta.absolutePositioned) {
            setupAbsolutePositionParent(node);
            absolutePositionSingleChildren(view, node, child);
            return;
        }

        if (child.meta.alignSelf === 'inherit') {
            child.styles.alignSelf = node.styles.alignItems;
        } else if (child.meta.alignSelf) {
            child.styles.alignSelf = child.meta.alignSelf;
        }
        if (child.meta.layoutGrow) {
            child.styles.flexGrow = child.meta.layoutGrow;
        }
    });
    if (node.children.some((child) => child.meta.absolutePositioned)) {
        node.children.forEach((child) => {
            if (!child.styles.position) {
                child.styles.position = 'relative';
            }
        });
    }
};
